import { jwtDecode } from 'jwt-decode';

export const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;

    return decoded.exp && decoded.exp > now;
  } catch (error) {
    console.log('Token expirado. Precisará fazer login');

    return false;
  }
};
